import { generateTranslations } from '../i18n/translation';

const namespace = 'practiceactivity/roles';

const translations = generateTranslations(namespace, {
  uhaHeader1: {
    nb: 'Kontaktperson ved studiested',
    en: 'Contact person',
  },
  psaHeader1: {
    nb: 'Medarbeider ved praksissted',
    en: 'Colleague',
  },
  header2: {
    nb: 'Rolle',
    en: 'Role',
  },
  header3: {
    nb: 'Epost',
    en: 'Email',
  },
  header4: {
    nb: 'Mobil',
    en: 'Mobile',
  },
  header5: {
    nb: 'Handling',
    en: 'Action',
  },
  addUserVeileder: {
    nb: 'Legg til veileder',
    en: 'Add supervisor',
  },
  addUserUnderviser: {
    nb: 'Legg til underviser',
    en: 'Add tutor',
  },
  addUserKoordinator: {
    nb: 'Legg til koordinator',
    en: 'Add coordinator',
  },
  removeUser: {
    nb: 'Fjern rolle',
    en: 'Remove',
  },
  modalHeaderVeileder: {
    nb: 'Velg en veileder som du vil legge til praksisaktiviteten',
    en: 'Select supervisor to add',
  },
  modalHeaderUnderviser: {
    nb: 'Velg en underviser som du vil legge til praksisaktiviteten',
    en: 'Select tutor to add',
  },
  modalHeaderKoordinator: {
    nb: 'Velg en koordinator som du vil legge til praksisaktiviteten',
    en: 'Select coordinator to add',
  },
  access: {
    nb: 'Tilgangsnivå',
    en: 'Place',
  },
  name: {
    nb: 'Navn',
    en: 'Name',
  },
  cancel: {
    nb: 'Avbryt',
    en: 'Cancel',
  },
  confirm: {
    nb: 'Legg til',
    en: 'Add',
  },
  addSuccessVeileder: {
    nb: 'Veileder lagt til praksisaktiviteten',
    en: 'Supervisor successfully added',
  },
  addSuccessUnderviser: {
    nb: 'Underviser lagt til praksisaktiviteten',
    en: 'Tutor successfully added',
  },
  addSuccessKoordinator: {
    nb: 'Koordinator lagt til praksisaktiviteten',
    en: 'Coordinator successfully added',
  },
  removeSuccessVeileder: {
    nb: 'Veileder fjernet fra praksisaktiviteten',
    en: 'Supervisor successfully removed',
  },
  removeSuccessUnderviser: {
    nb: 'Underviser fjernet fra praksisaktiviteten',
    en: 'Tutor successfully removed',
  },
  removeSuccessKoordinator: {
    nb: 'Koordinator fjernet fra praksisaktiviteten',
    en: 'Coordinator successfully removed',
  },
  practicePlacesWithAgreement: {
    nb: 'Praksissteder med avtale',
    en: 'Practice places with agreement',
  },
  nopracticeUserDownMsg: {
    nb: 'Ingen brukere tilgjengelig for valgt prakissted.',
    en: 'No users available for the selected practice place.',
  },
  praksisstederInfoTekstKapasitet: {
    nb: 'Du kan kun legge til veileder på praksissteder som har meldt inn kapasitet.',
    en: 'You can only add a supervisor from practice places which has reported capacity.',
  },
  praksisstederInfoTekstIngenKapasitet: {
    nb: 'Ingen praksissteder har meldt inn kapasitet',
    en: 'No practice places have reported any capacity',
  },
});

export default translations;
